import { FunctionComponent } from 'react';
import { Overlay, OverlayHeader, OverlayImage, OverlayMessage } from 'components/overlays';
import { ReactComponent as NotFoundOverlayImage } from './NotFoundOverlay.image.svg';

export const NotFoundOverlay: FunctionComponent = props => {
  const { children } = props;

  return (
    <Overlay>
      <OverlayImage>
        <NotFoundOverlayImage />
      </OverlayImage>
      <OverlayHeader>Not found</OverlayHeader>
      <OverlayMessage>{children}</OverlayMessage>
    </Overlay>
  );
};
